import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import JobCategories from "../AdminComponents/JobCategories";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance";
const PublishedForms = () => {
  debugger;
  //published forms that change the initiated fields 
  const [forms, setForms] = useState([]);
  const navigate = useNavigate();
    const [blocked, setBlocked] = useState(false);

  const fetchForms = () => {debugger;

    // Retrieve user object from local storage
  const user = JSON.parse(localStorage.getItem("user"));
  const userId=user.id;

  // Extract JobId from user object
  const jobCategoryId = user?.jobCategoryId;
console.log("jobcategory", jobCategoryId);
debugger;
  // Check if jobCategoryId is valid
  // if (!jobCategoryId || jobCategoryId === "00000000-0000-0000-0000-000000000000") {
  //   console.warn("Invalid or missing Job Category ID. Forms cannot be fetched.");
  //   return;
  // }
    api
      .get(`/PublishedForms/GetPublishedForms?jobCategoryId=${jobCategoryId}&userid=${userId}`)
      .then((response) => {
        if (response.status === 200) {
          debugger;
          console.log("Forms fetched successfully:", response.data);
          const validForms = Array.isArray(response.data) ? response.data : [response.data];
          setForms(validForms);
        } else {
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {    
        console.error("Error fetching forms:", error);
      });
  };

  useEffect(() => {
    fetchForms();
  }, []); // Fetch data only on component mount

  const handleInitiate = (recordGuid,forOneTimeUse) => {
    debugger;
    const user = JSON.parse(localStorage.getItem("user"));  
    const createdById = user?.id; // Assuming fullName contains the username
    const createdByName = user?.fullName;
    if (!createdByName || !createdById) {
      alert("User not found. Please log in again.");
      return;
    }
     setBlocked(true);
  
    const url = `/PublishedForms/Initiate?recordGuid=${recordGuid}&createdById=${createdById}&createdByName=${createdByName}`;
  
    api
      .post(url, {}, { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        debugger;
        if (response.status === 200) {
          setBlocked(false);
           $.alert({
                  title: 'Success',
                  content: 'Form initiated successfully. Please wait while we redirect you to the same',
                  type: 'green',
                  buttons: {
                  okay: {
                    text: 'Ok',
                    btnClass: 'btn-green',
                    action: function () {
                      navigate(`/editor/MyForms`);
                    }
                  }
                }
                });
          console.log("Form copied successfully:", response.data);
        } else {
            $.alert({
                  title: 'Success',
                  content: 'Failed to initiate form.!',
                  type: 'red'
                });
          console.warn("Unexpected response:", response);
        }
      })
      .catch((error) => {
        console.error("Error copying form:", error);
        alert("Failed to initiate form. Please check the console for details.");
      });
  };
  
  
  useEffect(() => {
    if (forms.length > 0) {
      setTimeout(() => {
        if (window.$ && window.$.fn.DataTable) {
          window.$("#example1").DataTable({
            responsive: true,
            autoWidth: false,
            searching: true,
            ordering: true,
            pageLength: 10,
            lengthChange: false,
            paging: true,
            info: true,
            destroy: true, // Prevent duplication
          });
        }
      }, 300); // Slight delay to ensure table is in the DOM
    }
  }, [forms]); // Runs when `forms` is updated

  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};

  return (
    <div>
      {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
      <div>
        <div className="card card-success">
         <div className="card-header">
        <h3 className="card-title">Published Forms</h3>
      </div>
      {/* <h2>Published Forms</h2> */}
         <div className="card-body">
      <table id="example1" className="table table-bordered table-striped">
        <thead>
          <tr>
            <th width="54%">Name</th>   
            <th width="20%">Category</th>
            <th width="20%">Sub-Category</th>
            <th width="6%">Action</th>
          </tr>
        </thead>
        <tbody>
          {forms.length > 0 ? (
            forms.map((form) => (
              <tr key={form.id}>
                <td>{form.name}</td>
                <td>{form.formCategoryName}</td>
                <td>{form.formSubCategoryName}</td>
                {/* <td>{form.publishedOn ? moment(form.publishedOn).format("YYYY-MM-DD") : "N/A"}</td>
                <td>{form.expiryDate ? moment(form.expiryDate).format("YYYY-MM-DD") : "No Expiry"}</td> */}
                <td>  
                   <button
                    className="btn btn-sm btn-success"
                    title="Initiate"
                    onClick={() => handleInitiate(form.id)}
                  >Initiate</button></td>
              </tr>
            )))
           : (
            <tr>
              <td colSpan="5" className="text-center">No published forms available.</td>
            </tr>
          )}
        </tbody>
      </table>
</div>
</div>
      </div>
    </div>
  );
};

export default PublishedForms;
